export default __webpack_public_path__ + "static/media/colorful_windows_building.0c1e4ad6.jpg";